export default "__VITE_ASSET__0IiTkpFs__"